module.exports = __webpack_public_path__ + "static/media/t1-img3.2cf1323a.png";